import { styled } from '@linaria/react';

import { fonts, layout, primitives, semantic, space } from '../../theme/tokens';

export const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-600']};
  max-width: ${layout.narrowMaxWidth};
  margin: 0 auto;
`;

export const Paragraph = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  color: ${semantic.text.primary};
  line-height: ${primitives.typography.lineHeight.loose};
  margin: 0;
`;

export const ParagraphEmphasis = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.bold};
  color: ${semantic.text.primary};
  line-height: ${primitives.typography.lineHeight.loose};
  margin: 0;
`;

export const FormStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
`;

export const IntroStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
`;

export const ActionRow = styled.div`
  display: flex;
  padding-top: ${space['space-200']};
`;
